<template>
  <div class="w-96 bg-white flex flex-col">
    <div class="h-16 px-4 bg-blue-600 flex items-center gap-4 text-white">
      <p class="text-2xl">{{ $t('mirroring.serviceName') }}</p>
      <p class="leading-6">{{ $t('mirroring.tmMirroring') }}<br>{{ $t('mirroring.title') }}</p>
    </div>
    <div class="h-12 px-4 bg-blue-700 flex justify-between items-center text-white">
      <div class="flex items-center gap-2">
        <span class="w-2.5 h-2.5 rounded-full bg-white"></span>
        <p class="text-xl">{{ customer.connect.status ? $t('mirroring.consulting') : $t('mirroring.waiting') }}</p>
      </div>
      <div>
        <p class="text-2xl">{{ time }}</p>
      </div>
    </div>
    <div class="min-h-0 flex-1 pt-7 pl-7 pb-7 flex flex-col gap-6 overflow-y-auto">
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.userName') }}</p>
        <p class="text-xl font-bol`d">{{ customer.name }}</p>
        <span class="w-full h-px mt-2 bg-gray-200"></span>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.identification') }}</p>
        <p class="text-xl font-bold">{{ customer.residentRegistrationNumber }}</p>
        <span class="w-full h-px mt-2 bg-gray-200"></span>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.contact') }}</p>
        <p class="text-xl font-bold">{{ customer.phone }}</p>
        <span class="w-full h-px mt-2 bg-gray-200"></span>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.device') }}</p>
        <div class="text-xl font-bold flex flex-col gap-4">
          <p v-html="customer.device.model" />
          <p>{{ $t('mirroring.resolution') }}: {{ customer.device.resolution }}</p>
        </div>
        <span class="w-full h-px mt-2 bg-gray-200"></span>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.connectStatus') }}</p>
        <div class="flex items-center gap-2">
          <div class="w-6 h-6 rounded-full transition-all bg-center"
               :class="[
                  customer.connect.status ? 'bg-green-500 bg-check-white' : 'border border-gray-300',
               ]"
          ></div>
          <p class="text-xl font-bold"
             :class="[
                customer.connect.status ? 'text-green-500' : 'text-gray-300',
             ]"
          >{{ customer.connect.status ? $t('mirroring.connect') : $t('mirroring.disconnect') }}</p>
        </div>
        <span class="w-full h-px mt-2 bg-gray-200"></span>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-600">{{ $t('mirroring.userPermission') }}</p>
        <div class="flex flex-col gap-2">
          <label for="role-draw" class="w-max flex items-center gap-2 text-xl font-bold cursor-pointer">
            <div class="w-6 h-6 rounded-full transition-all bg-center"
                 :class="[
                     customer.role.draw ? 'border border-blue-500 bg-blue-500 bg-check-white' : 'border border-gray-300',
                 ]"
            ></div>
            <span>{{ $t('mirroring.drawPermission') }}</span>
            <input type="checkbox" id="role-draw" class="hidden" :checked="customer.role.draw" @input="onChangeCustomerRole($event, 'draw')" />
          </label>
          <label for="role-scroll" class="w-max flex items-center gap-2 text-xl font-bold cursor-pointer">
            <div class="w-6 h-6 rounded-full transition-all bg-center"
                 :class="[
                     customer.role.scroll ? 'border border-blue-500 bg-blue-500 bg-check-white' : 'border border-gray-300',
                 ]"
            ></div>
            <span>{{ $t('mirroring.scrollPermission') }}</span>
          </label>
          <input type="checkbox" id="role-scroll" class="hidden" :checked="customer.role.scroll" @input="onChangeCustomerRole($event, 'scroll')" />
        </div>
      </div>
    </div>
    <div>
      <button class="w-full h-16 bg-red-500 text-xl text-white transition hover:bg-red-600">{{ $t('mirroring.stop') }}</button>
    </div>
  </div>
</template>

<script>
import {RoomMirroring} from "@/core/api/room.mirroring.api";

export default {
  name: 'RoomMirroringSidebar',
  data() {
    return {
      timeSecond: 0,
      customer: {
        name: '',
        residentRegistrationNumber: '',
        phone: '',
        device: {
          model: '',
          resolution: '',
        },
        connect: {
          status: false,
        },
        role: {
          draw: true,
          scroll: true,
        },
      }
    }
  },
  created() {
    this._event = _Event()
    this._events = _Events()
    this.$roomApi.addEventListeners(this._event, this);

    this.startTime();
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._event);
  },
  computed: {
    time() {
      let hh = Math.floor(this.timeSecond / 3600);
      let mm = Math.floor((this.timeSecond - hh * 3600) / 60);
      let ss = this.timeSecond - hh * 3600 - mm * 60;

      // 시간, 분, 초가 한 자리 숫자일 경우 앞에 0을 추가
      hh = hh < 10 ? `0${hh}` : hh;
      mm = mm < 10 ? `0${mm}` : mm;
      ss = ss < 10 ? `0${ss}` : ss;

      return `${hh}:${mm}:${ss}`;
    }
  },
  watch: {
    'customer.role.draw': function(val) {
      RoomMirroring.sendEvent({
        type: 'room_mirroring_change_customer_role',
        data: {
          customer: {
            role: {
              draw: val,
            }
          }
        }
      });
    },
    'customer.role.scroll': function(val) {
      RoomMirroring.sendEvent({
        type: 'room_mirroring_change_customer_role',
        data: {
          customer: {
            role: {
              scroll: val,
            }
          }
        }
      });
    },
  },
  methods: {
    startTime() {
      setInterval(() => {
        this.timeSecond++;
      }, 1000);
    },
    onChangeCustomerRole(e, type) {
      this.customer.role[type] = e.currentTarget.checked;
    },
    updateCustomerInfo({ name, residentRegistrationNumber, phone, model, screenWidth, screenHeight, status }) {
      if (!status) {
        this.customer.name = '';
        this.customer.residentRegistrationNumber = '';
        this.customer.phone = '';
        this.customer.device.model = '';
        this.customer.device.resolution = '';
        this.customer.connect.status = status;
        return;
      }

      this.customer.name = name;
      this.customer.residentRegistrationNumber = residentRegistrationNumber;
      this.customer.phone = phone;
      this.customer.device.model = model;
      this.customer.device.resolution = `${screenWidth} * ${screenHeight}`;
      this.customer.connect.status = status;
      this.customer.role.draw = true;
      this.customer.role.scroll = true;
    },
  }
}

function  _Event() {
  return {
    room_mirroring_event: function (e) {
      let event = e && e.data
      let listener = this._events[event.type];

      event.userId = e.userId
      event.toUserId = e.userId

      if(!listener){
        return;
      }
      listener.call(this, event);
    },
    room_user_leave: function(e) {
      this.updateCustomerInfo({
        status: false,
      });
    },
  }
}
function _Events() {
  return {
    room_mirroring_customer_info: function(e) {
      this.updateCustomerInfo({
        ...e.data,
        status: true,
      });
    },
  }
}
</script>